import { Component, Injector, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GtmEventIds } from 'src/app/constants/gtm-event-ids';
import { EditDriversModalActionsVm } from 'src/app/models/app/edit-drivers-modal-action';
import { QuoteSteps } from 'src/app/models/enums/quote-steps';
import { QuoteStepBase } from 'src/app/pages/quote-step-base/quote-step-base';
import { DriversService } from 'src/app/services/drivers-service/drivers.service';
import { WinbackService } from 'src/app/services/winback/winback.service';
import { XsellService } from 'src/app/services/xsell-service/xsell.service';
import * as strings from './edit-drivers-modal.component.strings';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-edit-drivers-modal',
    templateUrl: './edit-drivers-modal.component.html',
    styleUrls: ['./edit-drivers-modal.component.scss'],
    imports: [BaseModalComponent, NgClass]
})
export class EditDriversModalComponent extends QuoteStepBase implements OnInit {

    public modalActions: EditDriversModalActionsVm = new EditDriversModalActionsVm();
    @Input() set inputs(value: EditDriversModalActionsVm) {
        this.modalActions = value;
    }
    @Input() inProcessModal: boolean = false;
    public driversList: Array<any> | undefined;

    public s = strings;
    public isChangeToComp: boolean | undefined;
    public differenceValue: number | undefined;
    public waiting: boolean = false;
    public indexToRemove: number | undefined = undefined;
    public gtmEventIds = GtmEventIds;
    private hasRemovedDriver: boolean = false;
    private willEditDriver: boolean = false
    private willAddDriver: boolean = false
    public get showAdditionalDriverLink() {
        return this.driversService.canAddAD();
    }

    constructor(
        public override injector: Injector,
        private driversService: DriversService,
        public activeModal: NgbActiveModal,
        private winbackService: WinbackService,
        private xsellService: XsellService
    ) {
        super(injector)
    }

    ngOnInit(): void {
        this.driversList = this.driversService.getProposerAndAd();
    }

    async onAction() {
        this.waiting = true;
        if (this.hasRemovedDriver && !this.willEditDriver) {
            this.motorQuoteStateService.setStepState(QuoteSteps.getQuote);
        }

        if (this.modalActions && this.modalActions.customAction) {
            await this.modalActions.customAction();
        }

        this.close();
    }

    public close(): any {
        if (this.hasRemovedDriver && !this.willEditDriver && !this.willAddDriver) {
            this.motorQuoteStateService.setStepState(QuoteSteps.getQuote);
        }
        if (this.modalActions && this.modalActions.customAction) {
            this.modalActions.customAction();
        }
        this.activeModal.close();
    }

    public onAddAdditionalDrivers(event: Event): void {
        this.triggerGtmEvent(GtmEventIds.addDriver, event);
        this.willAddDriver = true;
        this.winbackService.setWinbackRatingVersion(undefined);
        this.motorQuoteStateService.setStepState(QuoteSteps.aD_Name);
        this.close();
    }

    public onEditAdditionalDriver(index: number, event: Event) {
        if (index) {
            this.driversService.editAdditionalDriver(index - 1);
        } else {
            this.motorQuoteStateService.setIsQuoteInEditMode(true);
            this.winbackService.setWinbackRatingVersion(undefined);
            if (this.xsellService.checkXsellSelected() && this.winbackService.getIsWinbackQuote() === false) {
                this.motorQuoteStateService.setStepState(QuoteSteps.aboutYou);
            } else {
                this.motorQuoteStateService.setStepState(QuoteSteps.hasOtherPolicies);
            }
        }
        this.willEditDriver = true;
        this.close();
        this.triggerGtmEvent(GtmEventIds.driversEdit, event);
    }

    public onDeleteAdditionalDriver(index: number): void {
        this.indexToRemove = index;
    }

    public onConfirmDeleteAdditionalDriver(index: number, event: Event): void {
        this.driversService.deleteAdditionalDriver(index - 1);
        this.driversList?.splice(index, 1);
        this.indexToRemove = undefined;
        this.hasRemovedDriver = true;
        this.winbackService.setWinbackRatingVersion(undefined);
        this.triggerGtmEvent(GtmEventIds.driversRemove, event);
    }

    public triggerGtmEvent(name: string, event: Event) {
        const targetElement = (event.target as HTMLElement).closest('button');
        this.googleTagManagerService.trackAction({
            event: 'button_click',
            action: 'click',
            html_id: targetElement?.id,
            name: name
        });
    }
}
